import { NgModule } from '@angular/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AdministrarCodigoReutilizableRouting } from './administrar-codigo-reutilizable-routing.component';
import { AdministrarCodigoReutilizableComponent } from './administrar-codigo-reutilizable.component';
import { ConsultarInformacionCodigoComponent } from './consultar-informacion-codigo/consultar-informacion-codigo.component';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
}


@NgModule({
  declarations: [AdministrarCodigoReutilizableComponent, ConsultarInformacionCodigoComponent],
  imports: [
    AdministrarCodigoReutilizableRouting,
    SharedModule,
    CommonModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true
    })
  ],
  entryComponents: [
    ConsultarInformacionCodigoComponent
  ]
})

export class AdministrarCodigoReutilizableModule { }
